import { useGetApiTestSimulateError } from "../../../openapi/backendApi";

import { ReactNode, useState } from "react";

import { Box, Button, InputAdornment, TextField } from "@mui/material";

export default function DevErrorTester(): ReactNode {
  const [errorCode, setErrorCode] = useState<number | undefined>();
  const {
    data: errorData,
    error,
    refetch,
    isFetching,
  } = useGetApiTestSimulateError(
    { statusCode: errorCode },
    { query: { enabled: false, retry: false } },
  );

  const handleSetErrorCode = (value: string): void => {
    setErrorCode(Number(value.trim()));
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <TextField
        variant="outlined"
        label={"API Error Test"}
        value={errorCode}
        type="number"
        onChange={(e) => {
          handleSetErrorCode(e.target.value);
        }}
        sx={{ backgroundColor: "#fff" }}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <Button
                  onClick={() => {
                    refetch();
                    console.log("errorData", errorData, "error", error);
                  }}
                  disabled={isFetching}
                  variant="outlined"
                  color="primary"
                >
                  Test
                </Button>
              </InputAdornment>
            ),
          },
        }}
      />
    </Box>
  );
}
